
import adsConfig from '../assets/ads.json';

const adSenseAccount = 'ca-pub-3740268378454082';

export default {
  name: 'SAdSense',
  props: {
    uniqId: {
      type: Number,
      default: 0,
    },
    adName: {
      type: String,
      required: true,
    },
    spaceA: {
      type: Boolean,
      default: false,
    },
    spaceX: {
      type: Boolean,
      default: false,
    },
    spaceY: {
      type: Boolean,
      default: false,
    },
    spaceT: {
      type: Boolean,
      default: false,
    },
    spaceR: {
      type: Boolean,
      default: false,
    },
    spaceB: {
      type: Boolean,
      default: false,
    },
    spaceL: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      adSenseAccount,
      adsConfig,
      slot: null,
      isVisible: false,
    };
  },
  adName: {
    immediate: true,
    handler() {
    },
  },
  computed: {
    idDiv() {
      return `${this.uniqId}-${this.adName}`;
    },
  },
  updated() {
    this.destroy();
    this.display();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    display() {
      if (this.slot === null && this.isVisible) {
        try {
          window.googletag.cmd.push(() => {
            this.slot = window.googletag.defineSlot(adsConfig[this.adName].slot, adsConfig[this.adName].format, this.idDiv).addService(window.googletag.pubads());
            this.$nextTick(() => {
              window.googletag.display(this.idDiv);
              window.googletag.pubads().refresh([this.slot]);
            });
          });
        } catch (e) {
          this.$bugsnag.notify(e);
        }
      }
    },
    destroy() {
      if (this.slot) {
        window.googletag.cmd.push(() => {
          window.googletag.destroySlots([this.slot]);
          this.slot = null;
        });
      }
    },
    handleVisibility(isVisible) {
      this.isVisible = isVisible;
      this.display();
    },
  },
};
